export default __webpack_public_path__ + "static/media/Group1497-Rotate.079c9ed7.png";